import React, { useCallback, useMemo } from 'react';
// eslint-disable-next-line import/no-cycle
import SiteSearch from './index';

interface SiteSearchContextReturnable {
    visible: boolean;
    setVisible: (visible: boolean) => void;
}

const SiteSearchContext = React.createContext<SiteSearchContextReturnable | null>(null);

const SiteSearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }): JSX.Element => {
    const [visible, setVisible] = React.useState<boolean>(false);

    const handleSetVisible = useCallback((value: boolean): void => {
        setVisible(value);
    }, []);

    const context = useMemo<SiteSearchContextReturnable>(() => ({
        visible,
        setVisible: handleSetVisible,
    }), [visible, handleSetVisible]);

    return (
        <SiteSearchContext.Provider value={context}>
            {children}
            <SiteSearch />
        </SiteSearchContext.Provider>
    );
};

export const useSiteSearch = (): SiteSearchContextReturnable => {
    const data = React.useContext(SiteSearchContext);
    if (!data) {
        throw new Error('useSiteSearch used outside of context');
    }
    return data;
};

export default SiteSearchProvider;
